function initUploadImage() {
  // Image processing stays on innovative-stack. Credits go through the bridge so
  // Ampt ledger and Shopify Jetons PMD+ (custom.sub_usage) stay in sync.
  const IMAGE_API_BASE = "https://innovative-stack-i1z8l.ampt.app/api/v1";
  const CREDIT_API_BASE =
    window.SHERPA_CREDIT_API_BASE ||
    "https://innovative-stack-i1z8l.ampt.app/api/v1";
  const API_BASE = IMAGE_API_BASE;

  const uploadRefs = {
    before: document.querySelector("#product__upload--image__result--modal .product__upload--image__result--before"),
    after: document.querySelector("#product__upload--image__result--modal .product__upload--image__result--after"),
    afterImage: document.querySelector("#product__upload--image__result--modal .product__upload--image__result--after svg"),
    modal: document.getElementById("product__upload--image__result--modal"),
    label: document.getElementById("upload--image__label"),
    input: document.getElementById("upload--image__trigger"),
    responseContainer: document.getElementById("response--image"),
    close: document.getElementById("close_modal"),
    cancel: document.getElementById("upload_download_cancel"),
    sizeText: document.querySelector(".size__text"),
    customerIdInput: document.getElementById("customer-id"),
    creditsMessage: document.getElementById("credits--message"),
    creditsRemaining: document.getElementById("credits--remaining"),
    creditsCount: document.getElementById("credits--count"),
  };

  const MAX_MB = 10;

  const isLogged = typeof window.userIsLoggedIn !== "undefined" ? !!window.userIsLoggedIn : false;
  const customerId = uploadRefs.customerIdInput?.value || null;
  const loadingOverlay = document.querySelector(".loading__overlay");
  const loadingCancelBtn = document.getElementById("sherpa-ai-loading-cancel");
  let activeAbortController = null;

  // Escape header / left-nav stacking contexts
  [uploadRefs.modal, loadingOverlay].forEach((el) => {
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  });

  const goLogin = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    const ret = encodeURIComponent(location.pathname + location.search + location.hash);
    window.location.href = "/account/login?return_url=" + ret;
  };

  if (uploadRefs.label) {
    ["dragenter", "dragover", "dragleave", "drop"].forEach((evt) => {
      uploadRefs.label.addEventListener(evt, (e) => { e.preventDefault(); e.stopPropagation(); }, { capture: true });
    });
  }

  if (!isLogged) {
    uploadRefs.label?.addEventListener("click", goLogin, { capture: true });
    uploadRefs.input?.addEventListener("click", goLogin, { capture: true });
    uploadRefs.input?.addEventListener("change", goLogin, { capture: true });

    document.querySelectorAll(".product__upload--label").forEach((item, idx) => {
      item.style.display = idx === 0 ? "flex" : "none";
    });
    return;
  }

  let currentCredits = null;
  let downloadInFlight = false;

  const updateCreditsUI = (balance) => {
    currentCredits = balance;

    if (balance <= 0) {
      uploadRefs.creditsMessage?.classList.add("active");
      uploadRefs.label?.classList.add("disabled");
      if (uploadRefs.creditsRemaining) uploadRefs.creditsRemaining.style.display = "none";
    } else {
      uploadRefs.creditsMessage?.classList.remove("active");
      uploadRefs.label?.classList.remove("disabled");
      if (uploadRefs.creditsRemaining) uploadRefs.creditsRemaining.style.display = "block";
      if (uploadRefs.creditsCount) uploadRefs.creditsCount.textContent = balance;
    }
  };

  const fetchCredits = async () => {
    if (!customerId) return;
    try {
      const resp = await fetch(`${CREDIT_API_BASE}/credit/balance?customer_id=${customerId}`);
      if (!resp.ok) return;
      const data = await resp.json();
      updateCreditsUI(data.balance ?? 0);
    } catch (err) {
      console.warn("Credit check failed:", err);
    }
  };

  const useCredit = async () => {
    if (!customerId) return false;
    try {
      const resp = await fetch(`${CREDIT_API_BASE}/credit/use`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer_id: customerId }),
      });
      if (!resp.ok) return false;
      const data = await resp.json();
      updateCreditsUI(data.balance ?? (currentCredits - 1));
      return true;
    } catch (err) {
      console.warn("Credit use failed:", err);
      return false;
    }
  };

  const setDownloadButtonsLocked = (locked) => {
    document.querySelectorAll(".upload_download, .upload_download_pdf").forEach((btn) => {
      btn.style.pointerEvents = locked ? "none" : "";
      btn.style.opacity = locked ? "0.6" : "";
      btn.setAttribute("aria-busy", locked ? "true" : "false");
    });
  };

  fetchCredits();

  if (uploadRefs.input && uploadRefs.label) {
    uploadRefs.input.onchange = function () {
      const file = this.files?.[0];
      if (file && file.size > MAX_MB * 1024 * 1024) {
        uploadRefs.sizeText?.classList.add("active");
        uploadRefs.label.style.outline = "2px solid red";
        this.value = "";
      } else {
        uploadRefs.sizeText?.classList.remove("active");
        uploadRefs.label.style.outline = "2px solid yellow";
      }
    };
  }

  uploadRefs.modal?.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      event.currentTarget.classList.add("hide");
      setTimeout(() => window.location.reload(), 1000);
    }
  });

  uploadRefs.close?.addEventListener("click", () => {
    uploadRefs.modal?.classList.add("hide");
    setTimeout(() => window.location.reload(), 1000);
  });

  uploadRefs.cancel?.addEventListener("click", () => {
    uploadRefs.modal?.classList.add("hide");
    setTimeout(() => window.location.reload(), 1000);
  });

  function imageInputHandler() {
    if (!uploadRefs.label || !uploadRefs.input) return;

    const fileManager = async (file) => {
      if (!file) return;

      if (currentCredits !== null && currentCredits <= 0) {
        alert("Vous n'avez plus de crédits. Veuillez en acheter.");
        return;
      }

      if (file.size > MAX_MB * 1024 * 1024) {
        uploadRefs.sizeText?.classList.add("active");
        uploadRefs.label.style.outline = "2px solid red";
        alert(`File is larger than ${MAX_MB}MB`);
        return;
      }

      // Ampt /images requires customer_id (422 without it). Jetons are still
      // charged only via CREDIT_API_BASE /credit/use on PDF/SVG download —
      // preview/production with customer_id does not debit the bridge.
      const formData = new FormData();
      formData.append("image", file);
      formData.append("mode", "preview");
      formData.append("max_colors", 50);
      formData.append("file_format", "png");
      formData.append("customer_id", customerId || "");

      uploadRefs.label.style.outline = "2px solid yellow";

      const loading = loadingOverlay || document.querySelector(".loading__overlay");
      const preloader = loading?.querySelector(".preloader") || document.querySelector(".loading__overlay .preloader");
      let progress = 0, interval;

      function slowProgress() {
        if (!preloader) return;
        interval = setInterval(() => {
          if (progress < 99) {
            progress++;
            preloader.textContent = progress + "%";
          }
        }, 500);
      }

      const cleanupLoading = () => {
        if (interval) clearInterval(interval);
        interval = null;
        loading?.classList.remove("active");
        if (preloader) preloader.textContent = "0%";
        progress = 0;
        activeAbortController = null;
        if (uploadRefs.input) uploadRefs.input.value = "";
      };

      const onLoadingCancel = () => {
        activeAbortController?.abort();
        cleanupLoading();
      };
      loadingCancelBtn?.addEventListener("click", onLoadingCancel);

      const reader = new FileReader();
      reader.onload = function () {
        if (uploadRefs.before) {
          const img = document.createElement("img");
          img.src = reader.result;
          uploadRefs.before.innerHTML = "";
          uploadRefs.before.appendChild(img);
        }
      };
      reader.readAsDataURL(file);

      const stopWithError = (message) => {
        loadingCancelBtn?.removeEventListener("click", onLoadingCancel);
        cleanupLoading();
        uploadRefs.label.style.outline = "2px solid red";
        alert(message || "Upload failed. Please try again.");
      };

      try {
        activeAbortController = new AbortController();
        loading?.classList.add("active");
        slowProgress();

        const response = await fetch(`${API_BASE}/images`, {
          method: "POST",
          body: formData,
          signal: activeAbortController.signal,
        });
        if (!response.ok) throw new Error(`API error ${response.status}`);

        const blobImage = await response.blob();
        const resultUrl = URL.createObjectURL(blobImage);

        if (uploadRefs.after) {
          const img = document.createElement("img");
          img.src = resultUrl;
          uploadRefs.after.innerHTML = "";
          uploadRefs.after.appendChild(img);
          uploadRefs.after.classList.add("result_image");
        }

        if (interval) clearInterval(interval);
        const revealResult = () => {
          loadingCancelBtn?.removeEventListener("click", onLoadingCancel);
          cleanupLoading();
          uploadRefs.label.style.outline = "2px solid green";
          uploadRefs.modal?.classList.remove("hide");
        };
        if (preloader && loading) {
          const fastProgressInterval = setInterval(() => {
            if (progress < 100) {
              progress++;
              preloader.textContent = progress + "%";
            } else {
              clearInterval(fastProgressInterval);
              revealResult();
            }
          }, 10);
        } else {
          revealResult();
        }

        const addHoverZoom = (selector) => {
          const container = document.querySelector(selector);
          const element = container?.querySelector("img");
          if (!container || !element) return;
          container.addEventListener("mousemove", (event) => {
            const { left, top, width, height } = container.getBoundingClientRect();
            const mouseX = event.clientX - left;
            const mouseY = event.clientY - top;
            const offsetX = (mouseX / width - 0.5) * 3;
            const offsetY = (mouseY / height - 0.5) * 3;
            element.style.transformOrigin = `${50 + offsetX * 25}% ${50 + offsetY * 25}%`;
          });
          container.addEventListener("mouseenter", () => (element.style.transform = "scale(3)"));
          container.addEventListener("mouseleave", () => (element.style.transform = "scale(1)"));
        };
        addHoverZoom(".product__upload--image__result--before");
        addHoverZoom(".product__upload--image__result--after");

        const startProductionDownload = async (fileFormat, filename) => {
          if (downloadInFlight) return;
          downloadInFlight = true;
          setDownloadButtonsLocked(true);

          // Show spinner immediately — before the credit network call.
          if (interval) clearInterval(interval);
          progress = 0;
          if (preloader) preloader.textContent = "0%";
          loading?.classList.add("active");
          slowProgress();

          const credited = await useCredit();
          if (!credited) {
            downloadInFlight = false;
            setDownloadButtonsLocked(false);
            stopWithError("Vous n'avez plus de crédits. Veuillez en acheter.");
            return;
          }

          formData.set("mode", "production");
          formData.set("file_format", fileFormat);
          formData.set("customer_id", customerId || "");

          try {
            const response = await fetch(`${API_BASE}/images`, {
              method: "POST",
              body: formData,
            });
            if (!response.ok) throw new Error(`API error ${response.status}`);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
          } catch (error) {
            console.warn(`${fileFormat.toUpperCase()} download error`, error);
            downloadInFlight = false;
            setDownloadButtonsLocked(false);
            stopWithError(`${fileFormat.toUpperCase()} download failed.`);
            return;
          } finally {
            if (interval) clearInterval(interval);
            if (preloader && loading) {
              const fastProgressInterval = setInterval(() => {
                if (progress < 100) {
                  progress++;
                  preloader.textContent = "0%";
                } else {
                  clearInterval(fastProgressInterval);
                  loading.classList.remove("active");
                }
              }, 10);
            }
            setTimeout(() => window.location.reload(), 1000);
          }
        };

        // onclick replaces any previous handler (avoids stacked listeners / multi-debit).
        const svgBtn = document.querySelector(".upload_download");
        if (svgBtn) {
          svgBtn.onclick = (e) => {
            e.preventDefault();
            startProductionDownload("svg", "printmydtf_vectorized.svg");
          };
        }

        const pdfBtn = document.querySelector(".upload_download_pdf");
        if (pdfBtn) {
          pdfBtn.onclick = (e) => {
            e.preventDefault();
            startProductionDownload("pdf", "printmydtf_vectorized.pdf");
          };
        }

        const customDropdown = document.getElementById("custom_dropdown");
        customDropdown?.addEventListener("change", async () => {
          const selectedValue = customDropdown.value;
          formData.set("max_colors", selectedValue);

          loading?.classList.add("active");
          slowProgress();

          try {
            const response = await fetch(`${API_BASE}/images`, {
              method: "POST",
              body: formData,
            });
            if (!response.ok) throw new Error(`API error ${response.status}`);
            const blobImage = await response.blob();
            const imageUrl = URL.createObjectURL(blobImage);

            if (uploadRefs.after) {
              const img = document.createElement("img");
              img.src = imageUrl;
              uploadRefs.after.innerHTML = "";
              uploadRefs.after.appendChild(img);
              uploadRefs.after.classList.add("result_image");
            }
          } catch (error) {
            console.warn("Re-vectorize error", error);
            stopWithError("Re-vectorize failed.");
            return;
          } finally {
            if (interval) clearInterval(interval);
            if (preloader && loading) {
              const fastProgressInterval = setInterval(() => {
                if (progress < 100) {
                  progress++;
                  preloader.textContent = "0%";
                } else {
                  clearInterval(fastProgressInterval);
                  loading.classList.remove("active");
                }
              }, 10);
            }
          }
        });
      } catch (error) {
        if (error?.name === "AbortError") {
          loadingCancelBtn?.removeEventListener("click", onLoadingCancel);
          cleanupLoading();
          return;
        }
        console.warn("AI API error:", error);
        stopWithError("Upload failed. File may be too large or blocked by CORS.");
      }
    };

    uploadRefs.input.addEventListener("change", (event) => {
      const file = event.target.files?.[0];
      fileManager(file);
    });
  }

  imageInputHandler();

  document.querySelectorAll(".product__upload--label").forEach((item, idx) => {
    item.style.display = idx === 0 ? "flex" : "none";
  });
}

window.initUploadImage = initUploadImage;
document.addEventListener("DOMContentLoaded", initUploadImage, { once: true });